import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.shape.borderRadius,
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        position: 'relative',
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: theme.spacing(2),
        minHeight: 32,
    },
    titleGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(0.5),
    },
    description: {
        color: theme.palette.text.secondary,
    },
    actions: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(0.5),
    },
    actionsFloating: {
        position: 'absolute',
        top: theme.spacing(2),
        right: theme.spacing(3),
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(0.5),
    },
}));
